export const phoneMaxWidth = "750px";
export const padMaxWidth = "1200px";
export const mobileMaxWidth = "719px";
export const mobileWidth = "450px";

import { useMediaQuery } from "react-responsive";

export const useMediaSize = () => {
  const isPhoneMedia = useMediaQuery({
    maxWidth: phoneMaxWidth,
  });
  const isMobile = useMediaQuery({ maxWidth: mobileMaxWidth });
  const isPadMedia = useMediaQuery({
    maxWidth: padMaxWidth,
  });
  const isPhone = useMediaQuery({ maxWidth: mobileWidth });
  return {
    isPhoneMedia,
    isPadMedia,
    isMobile,
    isPhone,
  };
};
